"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from "react";
export const useBoolean = t0 => {
  const $ = _c(5);
  const defaultValue = t0 === undefined ? false : t0;
  const [value, setValue] = useState(defaultValue);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setValue(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const on = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setValue(false);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const off = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setValue(_temp);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const toggle = t3;
  let t4;
  if ($[3] !== value) {
    t4 = {
      value,
      on,
      off,
      toggle
    };
    $[3] = value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4 as const;
};
function _temp(prev) {
  return !prev;
}